/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import Home from './Home';

class Welcome extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Welcome';
  }

  render() {
    return (
      <Home {...this.props} /> // eslint-disable-line react/jsx-props-no-spreading
    );
  }
}

export default Welcome;
